<button
  (click)="pressed()"
  [ngClass]="{
    'button-active': active,
    'btn-tracker': widgetInfo.type === 'tracker'
  }"
>
  <img [src]="widgetInfo.image" [alt]="widget.column" />
  <p
    *ngIf="
      widgetInfo.type === 'tracker' && survey.tracker.parent;
      else otherSurveyCount
    "
  >
    {{ survey.tracker.counts.total_launched }}/{{ survey.trackerCount }}
  </p>
  <ng-template #otherSurveyCount>
    <p>{{ count }}</p>
  </ng-template>
</button>
